import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {ConfigService} from '@services/infra/config.service';
import {StammdatenResource} from '@services/resource/registration-resource';
import {ErrorService} from '@services/error.service';
import {catchError} from 'rxjs/operators';
import {LoggingService} from '@services/logging.service';
import {RegistrationProcessResource} from '@services/resource/registration-process-resource';
import {HttpIgnoringInterceptorsService} from '@services/http-ignoring-interceptors.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  constructor(
    private readonly errors: ErrorService,
    private readonly conf: ConfigService,
    private readonly http: HttpIgnoringInterceptorsService,
    private readonly logger: LoggingService,
  ) {}

  public register(r: StammdatenResource): Observable<RegistrationProcessResource | 'User exsists'> {
    this.logger.logInfo('attempting to register', {startup: r});
    const url = `${this.conf.backendUrl}/v1/registration`;
    return this.http.post<RegistrationProcessResource>(url, r).pipe(this.errors.withErrorHandler(), catchError(this.errorHandler));
  }

  private errorHandler(error: HttpErrorResponse | any): Observable<any> {
    const CONFLICT_REQUEST = 409;
    if (error instanceof HttpErrorResponse && error.status === CONFLICT_REQUEST) {
      return of('User exsists');
    } else {
      return throwError(error);
    }
  }
}
